import { useState, useEffect } from 'react';
import Modal from '..';
import useStore from '../../Hooks/useStore';
import Form from '../../Form';

export interface RecoverPasswordModalProps {}

const RecoverPasswordModal = ({}: RecoverPasswordModalProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
    form: { resetRecoverForm },
  } = setters;
  const isOpen = getModal('single.recoverPassword');
  const onClose = () => {
    closeSingleModal('recoverPassword');
    resetRecoverForm();
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Recuperar Senha"
      height={'auto'}
      width={'40vw'}
    >
      <Form.RecoverPassword.Request />
    </Modal>
  );
};

export default RecoverPasswordModal;
